import { Settings as LayoutSettings } from '@ant-design/pro-components';
/**
 * @name
 */
const Settings: LayoutSettings & {
  logo?: string;
} = {
  navTheme: 'light',
  // 拂晓蓝
  colorPrimary: '#1890ff',
  layout: 'mix',
  contentWidth: 'Fluid',
  fixedHeader: false,
  fixSiderbar: true,
  colorWeak: false,
  title: '',
  iconfontUrl: '',
};

export default Settings;
